export default class ReportLocation {
  constructor(locationId, locationTitle, locationIndex) {
    this.locationId = locationId;
    this.locationTitle = locationTitle;
    this.locationIndex = locationIndex;
    this.categories = [];
  }
}
